import { TOrdersFilters } from 'src/types/orders';

export enum ORDER_STATUS {
  DRAFT = 'df',
  ON_HOLD = 'h',
  WAITING_FOR_PAYMENT = 'w',
  PENDING = 'p',
  ACCEPTED = 'a',
  PROCESSING = 'pr',
  PICKEDUP = 'pi',
  OUT_FOR_DELIVERY = 'o',
  ASSIGNED = 'as',
  WAITING_FOR_PICKUP = 'da',
  COMPLETED = 'd',
  RETURNED = 'r',
  CANCELED = 'ca',
}

export type TGroupedStatusesOrdersKeys = 'pickupFoodics' | 'deliveryFoodics' | 'pickupKudu' | 'deliveryKudu' | 'pickup' | 'delivery';
export type TGroupedStatusesOrders = {
  [key in TGroupedStatusesOrdersKeys]: any[];
};
export const GROUPED_STATUSES_ORDERS: TGroupedStatusesOrders = {
  // foodics
  pickupFoodics: [
    ORDER_STATUS.PENDING,
    ORDER_STATUS.ACCEPTED,
    ORDER_STATUS.WAITING_FOR_PICKUP,
    ORDER_STATUS.RETURNED,
    ORDER_STATUS.COMPLETED,
    ORDER_STATUS.CANCELED,
  ],
  deliveryFoodics: [
    ORDER_STATUS.PENDING,
    ORDER_STATUS.ACCEPTED,
    ORDER_STATUS.WAITING_FOR_PICKUP,
    ORDER_STATUS.OUT_FOR_DELIVERY,
    ORDER_STATUS.RETURNED,
    ORDER_STATUS.COMPLETED,
    ORDER_STATUS.CANCELED,
  ],
  // kudu
  pickupKudu: [
    ORDER_STATUS.PENDING,
    ORDER_STATUS.ACCEPTED,
    ORDER_STATUS.PROCESSING,
    ORDER_STATUS.WAITING_FOR_PICKUP,
    ORDER_STATUS.RETURNED,
    ORDER_STATUS.COMPLETED,
    ORDER_STATUS.CANCELED,
  ],
  deliveryKudu: [
    ORDER_STATUS.PENDING,
    ORDER_STATUS.ACCEPTED,
    ORDER_STATUS.PROCESSING,
    ORDER_STATUS.WAITING_FOR_PICKUP,
    ORDER_STATUS.OUT_FOR_DELIVERY,
    ORDER_STATUS.RETURNED,
    ORDER_STATUS.COMPLETED,
    ORDER_STATUS.CANCELED,
  ],
  // without pos
  pickup: [
    ORDER_STATUS.PENDING,
    ORDER_STATUS.ACCEPTED,
    ORDER_STATUS.PROCESSING,
    ORDER_STATUS.WAITING_FOR_PICKUP,
    ORDER_STATUS.RETURNED,
    ORDER_STATUS.COMPLETED,
    ORDER_STATUS.CANCELED,
  ],
  delivery: [
    ORDER_STATUS.PENDING,
    ORDER_STATUS.ACCEPTED,
    ORDER_STATUS.PROCESSING,
    ORDER_STATUS.WAITING_FOR_PICKUP,
    ORDER_STATUS.OUT_FOR_DELIVERY,
    ORDER_STATUS.RETURNED,
    ORDER_STATUS.COMPLETED,
    ORDER_STATUS.CANCELED,
  ],
};

export type TGroupedOrdersKeys =
  | TOrdersFilters['ALL']
  | TOrdersFilters['ALL_ACTIVE']
  | TOrdersFilters['NEW_ACTIVE']
  | TOrdersFilters['IN_PROGRESS_ACTIVE']
  | TOrdersFilters['IN_DELIVERY_ACTIVE']
  | TOrdersFilters['RETURNED_ACTIVE']
  | TOrdersFilters['ALL_AHEAD']
  | TOrdersFilters['NEW_AHEAD']
  | TOrdersFilters['IN_PROGRESS_AHEAD']
  | TOrdersFilters['ALL_HISTORY']
  | TOrdersFilters['COMPLETED_HISTORY']
  | TOrdersFilters['CANCELED_HISTORY'];
export type TGroupedOrders = {
  [key in TGroupedOrdersKeys]?: string[];
};

export const HISTORY_ORDERS = [ORDER_STATUS.COMPLETED, ORDER_STATUS.CANCELED];

export enum ORDER_SECTIONS {
  ORDER,
  PICKUP,
  DELIVERY,
  DETAILS,
  DINE_IN,
}

export enum ORDER_DINE_IN_TYPE {
  DINE_IN = 1,
  TOGO = 2,
}

export enum ORDER_NOTIFICATION_TYPE {
  NEW,
  DRIVER_NOT_FOUND,
  CLIENT_ARRIVED,
}
// -------------- NEW
export enum ORDER_TYPE {
  ACTIVE = 'active',
  AHEAD = 'ahead',
  HISTORY = 'history',
  DRAFT = 'draft',
}

export enum ORDERS_GROUPS {
  ALL = 'all',
  NEW = 'new',
  IN_PROGRESS = 'in_progress',
  PROCESSING = 'processing',
  IN_DELIVERY = 'in_delivery',
  READY = 'ready',
  RETURNED = 'returned',
  COMPLETED = 'completed',
  CANCELED = 'canceled',
  WAITING = 'waiting',
  ON_HOLD = 'on_hold',
  DRAFT = 'draft',
  ACTIVE = 'active',
  CLOSED = 'closed',
  ACTION_REQUIRED = 'action_required',
  AHEAD = 'ahead',
}

export const LIVE_ORDERS_TYPES_GROUP = {
  [ORDERS_GROUPS.ALL]: [
    ORDER_STATUS.PENDING,
    ORDER_STATUS.ACCEPTED,
    ORDER_STATUS.PROCESSING,
    ORDER_STATUS.ASSIGNED,
    ORDER_STATUS.WAITING_FOR_PICKUP,
    ORDER_STATUS.OUT_FOR_DELIVERY,
    ORDER_STATUS.PICKEDUP,
    ORDER_STATUS.RETURNED,
  ],
  [ORDERS_GROUPS.NEW]: [ORDER_STATUS.PENDING, ORDER_STATUS.ACCEPTED],
  [ORDERS_GROUPS.PROCESSING]: [ORDER_STATUS.PROCESSING],
  [ORDERS_GROUPS.READY]: [ORDER_STATUS.WAITING_FOR_PICKUP],
  [ORDERS_GROUPS.IN_DELIVERY]: [ORDER_STATUS.ASSIGNED, ORDER_STATUS.PICKEDUP, ORDER_STATUS.OUT_FOR_DELIVERY],
  [ORDERS_GROUPS.CLOSED]: [ORDER_STATUS.CANCELED, ORDER_STATUS.COMPLETED],
  [ORDERS_GROUPS.ACTION_REQUIRED]: [ORDER_STATUS.RETURNED],
  [ORDERS_GROUPS.AHEAD]: [
    ORDER_STATUS.PENDING,
    ORDER_STATUS.ACCEPTED,
    ORDER_STATUS.PROCESSING,
    ORDER_STATUS.ASSIGNED,
    ORDER_STATUS.WAITING_FOR_PICKUP,
    ORDER_STATUS.OUT_FOR_DELIVERY,
    ORDER_STATUS.PICKEDUP,
    ORDER_STATUS.RETURNED,
  ],
};

export const ORDERS_TYPES_GROUP = {
  [ORDER_TYPE.ACTIVE]: {
    [ORDERS_GROUPS.ALL]: [
      ORDER_STATUS.PENDING,
      ORDER_STATUS.ACCEPTED,
      ORDER_STATUS.PROCESSING,
      ORDER_STATUS.ASSIGNED,
      ORDER_STATUS.WAITING_FOR_PICKUP,
      ORDER_STATUS.OUT_FOR_DELIVERY,
      ORDER_STATUS.PICKEDUP,
      ORDER_STATUS.RETURNED,
    ],
    [ORDERS_GROUPS.NEW]: [ORDER_STATUS.PENDING, ORDER_STATUS.ACCEPTED],
    [ORDERS_GROUPS.IN_PROGRESS]: [ORDER_STATUS.PROCESSING],
    [ORDERS_GROUPS.READY]: [ORDER_STATUS.WAITING_FOR_PICKUP],
    [ORDERS_GROUPS.IN_DELIVERY]: [ORDER_STATUS.ASSIGNED, ORDER_STATUS.PICKEDUP, ORDER_STATUS.OUT_FOR_DELIVERY],
    [ORDERS_GROUPS.RETURNED]: [ORDER_STATUS.RETURNED],
  },
  [ORDER_TYPE.AHEAD]: {
    [ORDERS_GROUPS.ALL]: [
      ORDER_STATUS.PENDING,
      ORDER_STATUS.ACCEPTED,
      ORDER_STATUS.PROCESSING,
      ORDER_STATUS.ASSIGNED,
      ORDER_STATUS.WAITING_FOR_PICKUP,
      ORDER_STATUS.OUT_FOR_DELIVERY,
      ORDER_STATUS.PICKEDUP,
      ORDER_STATUS.RETURNED,
    ],
    [ORDERS_GROUPS.NEW]: [ORDER_STATUS.PENDING, ORDER_STATUS.ACCEPTED],
    [ORDERS_GROUPS.IN_PROGRESS]: [ORDER_STATUS.PROCESSING],
    [ORDERS_GROUPS.READY]: [ORDER_STATUS.WAITING_FOR_PICKUP],
    [ORDERS_GROUPS.IN_DELIVERY]: [ORDER_STATUS.ASSIGNED, ORDER_STATUS.PICKEDUP, ORDER_STATUS.OUT_FOR_DELIVERY],
    [ORDERS_GROUPS.RETURNED]: [ORDER_STATUS.RETURNED],
  },
  [ORDER_TYPE.HISTORY]: {
    [ORDERS_GROUPS.ALL]: [ORDER_STATUS.CANCELED, ORDER_STATUS.COMPLETED],
    [ORDERS_GROUPS.COMPLETED]: [ORDER_STATUS.COMPLETED],
    [ORDERS_GROUPS.CANCELED]: [ORDER_STATUS.CANCELED],
  },
  [ORDER_TYPE.DRAFT]: {
    [ORDERS_GROUPS.ALL]: [ORDER_STATUS.DRAFT, ORDER_STATUS.WAITING_FOR_PAYMENT],
  },
};

export const CALL_CENTER_GROUP = {
  [ORDERS_GROUPS.ALL]: [
    ...ORDERS_TYPES_GROUP[ORDER_TYPE.ACTIVE][ORDERS_GROUPS.ALL],
    ...ORDERS_TYPES_GROUP[ORDER_TYPE.HISTORY][ORDERS_GROUPS.ALL],
    ...ORDERS_TYPES_GROUP[ORDER_TYPE.DRAFT][ORDERS_GROUPS.ALL],
    ORDER_STATUS.ON_HOLD,
  ],
  [ORDERS_GROUPS.DRAFT]: [ORDER_STATUS.DRAFT],
  [ORDERS_GROUPS.NEW]: [ORDER_STATUS.DRAFT],
  [ORDERS_GROUPS.ON_HOLD]: [ORDER_STATUS.WAITING_FOR_PAYMENT, ORDER_STATUS.ON_HOLD],
  [ORDERS_GROUPS.ACTIVE]: [
    ORDER_STATUS.PENDING,
    ORDER_STATUS.ACCEPTED,
    ORDER_STATUS.PROCESSING,
    ORDER_STATUS.WAITING_FOR_PICKUP,
    ORDER_STATUS.ASSIGNED,
    ORDER_STATUS.PICKEDUP,
    ORDER_STATUS.OUT_FOR_DELIVERY,
  ],
  [ORDERS_GROUPS.CLOSED]: [...ORDERS_TYPES_GROUP[ORDER_TYPE.HISTORY][ORDERS_GROUPS.ALL]],
  [ORDERS_GROUPS.ACTION_REQUIRED]: [ORDER_STATUS.RETURNED],
};
